import { render, staticRenderFns } from "./FieldErrorTips.vue?vue&type=template&id=64882b95&scoped=true"
import script from "./FieldErrorTips.vue?vue&type=script&lang=js"
export * from "./FieldErrorTips.vue?vue&type=script&lang=js"
import style0 from "./FieldErrorTips.vue?vue&type=style&index=0&id=64882b95&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64882b95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64882b95')) {
      api.createRecord('64882b95', component.options)
    } else {
      api.reload('64882b95', component.options)
    }
    module.hot.accept("./FieldErrorTips.vue?vue&type=template&id=64882b95&scoped=true", function () {
      api.rerender('64882b95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/dragItem/components/FieldErrorTips.vue"
export default component.exports